<template>
  <div class="backyanse">
    <MyHelloWorld :numer="number"></MyHelloWorld>
    <!-- 右边图标 -->
    <Righticon></Righticon>
    <el-row>
      <el-col :span="24">
        <el-container class="conta auto">
          <el-image class="img" :src="$t('menu.CustomerInspectionImg')" alt=""></el-image>
        </el-container>
      </el-col>
    </el-row>
    <div class="content">
      <el-row>
        <el-col :span="7">
         <Content>
            <template #MingChen>
              <div>{{ $t("menu.customer") }}</div>
            </template>

            <template #ContentEr>
              <div class="inlineer">
              <li>          <router-link to="/CustomerInspection">
                    <div style="color: #1d2088">{{ $t("menu.Instructions") }}</div></router-link>
                  </li> 
              </div>
            </template>

            <template #ContentSan>
              <div class="inlineer">
               <li><router-link to="/TestApplicationForm">
                  <div >{{ $t("menu.Testapplicationform") }}</div></router-link></li> 
              </div>
            </template>
            <template #ContentSi>
              <div class="inlineer">
              <li><div>  <router-link to="/TheReportQuery">{{ $t("menu.TheReportQuery") }}</router-link></div></li>
              </div>
            </template>
            <template #ContentWu>
              <div class="inlineer">
                <li> <router-link to="/TheInspectionProcess"><div>{{ $t("menu.TheInspectionProcess") }}</div></router-link></li>
              </div>
            </template>
          </Content>
        </el-col>
        <el-col :span="17">
          <div class="fff">
            <el-divider direction="vertical"></el-divider>
            <span class="Xjiao">{{ $t("menu.Instructions") }} </span>

            <div class="fff">
          <div v-for="(item,index) in ProjectList" :key="index">
            <p v-html="item.details"></p>
            </div>
          </div>
          </div>
          
        </el-col>
      </el-row>
    </div>
    <!-- 底部 -->
    <MyFooter> </MyFooter>
  </div>
</template>

<style scoped>
.el-divider--vertical {
  margin-left: 10px;
}
ul li {
  font-weight: 400;
  color: #333333;
  /* font-size: 14px; */
}
ul {
  margin-top: 0px;
}
.White {
  position: relative;
  top: 69px;
  height: 60px;
  width: 280px;
  background: #999999;
}
.conta {
  margin-top: 161px;
}
.SanJiao {
  position: relative;
  bottom: 40px;
  left: 228px;
}

.shisi {
  font-size: 14px;
  background: #ffffff;
  padding: 10px;
  padding-left: 20px;
}
.Xjiao {
  color: #1d2088;
  font-size: 20px;
      font-weight: bold;
    display: inline-block;
    padding: 20px 0px 0px;
}

.divider {
  background-color: #eeeeee;
}
.fff {
  background: #ffffff;
  margin: 20px 0px; 
  padding: 0px 10px;
  padding-bottom: 2px !important;
}
span {
  font-size: 16px;

  color: #333333;
}
p {
  color: #333333;
  font-size: 14px;
line-height: 20px;
  font-weight: 400;
}
a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
a:-webkit-any-link:focus,
a:-webkit-any-link:hover {
  color: #1d2088;
}
</style>

<script>
export default {
  name: "CustomerInspection",

  data() {
    return {
      number: "5-1",

          // 
           ProjectList: [],
           title:"",
    };
  },
  created: function () { 

    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }
    this.getSelectRubber()
    },
  methods: {
   async getSelectRubber() {
      const { data: res } = await this.$http.get(
        "/ContactUs/GetNoticeInfo",
        {
          params:{languageType: this.title },
        }
      );

      if (res.code !== 200) return console.log("数据请求失败! ");

      this.ProjectList = res.data;
  // console.log(this.ProjectList)
    },
  },
};
</script>